module.exports = __webpack_public_path__ + "static/media/invoice.e258d63f.svg";